<template lang="pug">
section#user-recruits.slide.p-text(v-if="!loading")
  .title
    subtitle(icon="‰" text="採用情報")
  .swiper-base-wrapper(v-if="recruits.length")
    swiper(
      :modules="modules"
      :slides-per-view="swiperOptions.slidesPerView"
      :space-between="swiperOptions.spaceBetween"
      :navigation="swiperOptions.navigation"
      :scrollbar="swiperOptions.scrollbar"
    )
      swiper-slide(v-for="recruit in recruits")
        a(:href="recruitUrl(recruit.recruitId)" target="_blank")
          img.slide-img.js-no-image(:src="recruit.imageFileUrl" alt="")
          p.slide-title {{ recruit.businessType }}
          p.slide-txt {{ recruit.title }}
    button.user-recruits-swiper-button.swiper-button-prev
      span.prev-allow
    button.user-recruits-swiper-button.swiper-button-next
    .swiper-scrollbar(slot="scrollbar")
  div.user-recruits-new-link(v-else)
    span 現在求人情報の掲載はございません。
    a(href="/users/recruits/new" v-if="isCurrentUserPage") 求人情報の登録はこちら
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import Subtitle from "~/components/Common/Subtitle.vue";
import { Swiper, SwiperSlide } from "swiper/swiper-vue.mjs";
import { Navigation, Scrollbar } from "swiper/modules";
import "swiper/swiper-bundle.css";
import RecruitsRepository from "~/repositories/RecruitsRepository";
import RecruitModel from "~/models/RecruitModel";

export default defineComponent({
  name: "UserRecruits",
  components: {
    Swiper,
    SwiperSlide,
    Subtitle
  },
  props: {
    userAccountId: {
      type: Number,
      required: true
    },
    isCurrentUserPage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const swiperOptions = {
      slidesPerView: 2,
      spaceBetween: 56,
      navigation: {
        nextEl: ".user-recruits-swiper-button.swiper-button-next",
        prevEl: ".user-recruits-swiper-button.swiper-button-prev"
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
      }
    };
    const recruits = ref<Array<RecruitModel>>([]);
    const loading = ref<boolean>(true);
    const getRecruits = async () => {
      try {
        const params = {
          q: {
            user_account_user_account_id_eq: props.userAccountId
          }
        };
        const repo = new RecruitsRepository();
        recruits.value = await repo.index(params);
      } catch (e) {
        alert("採用情報の取得に失敗しました。時間を置いて再度お試しください。");
        console.log(e);
      } finally {
        loading.value = false;
      }
    };

    const recruitUrl =  (recruitId) => {
      return `/corporation/${props.userAccountId}/recruits/${recruitId}`;
    };

    onMounted(async () => {
      await getRecruits();
    });

    return {
      swiperOptions,
      recruits,
      loading,
      recruitUrl,
      modules: [Navigation, Scrollbar]
    };
  }
});
</script>

<style scoped lang="scss">
.title {
  margin-bottom: 20px;
}

.slide {
  margin-bottom: 71px;
}

.swiper-base-wrapper {
  position: relative;
}

.swiper-pagination-bullet {
  display: none;
}

.swiper-scrollbar-drag {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
}

.swiper-scrollbar {
  height: 5px;
}

.swiper-wrapper {
  padding: 0;
  overflow-x: scroll;

  a:hover {
    text-decoration: none;
  }
}

.swiper {
  width: 100%;
  height: 400px;
}

.swiper2 {
  position: relative;
  width: 100%;
  height: 200px;
}

.slide li:hover,
.any-company-list:hover {
  opacity: 0.8;
}

.swiper-button-prev,
.swiper-button-next {
  border-radius: 40px;
  background-color: #191919;
  color: white;
  padding: 30px;
  text-align: center;
  width: 10px;
  height: 10px;
  border: none;

  @media screen and (max-width: 850px) {
    display: none;
  }
}

.swiper-button-next {
  right: 10px;
  left: auto;
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}

.slide-img {
  width: 100%;
  height: 280px;
  object-fit: cover;

  @media screen and (max-width: 850px) {
    height: 90px;
  }
}

.slide-title {
  font-size: 12px;
  color: #00b900;
  margin: 20px 0 10px;
}

.slide-txt {
  color: #707070;
  font-size: 16px;
  line-height: 160%;
  margin-bottom: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media screen and (max-width: 850px) {
    font-size: 12px;
    margin-bottom: 20px;
  }
}

.user-recruits-new-link {
  font-size: 14px;
  font-weight: normal;
  color: #707070;

  a {
    color: #00b900;
    text-decoration: underline;
  }
}
</style>
